"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.dashboard.selectGroupHint': 'Seleziona un gruppo per visualizzare i messaggi',
    'whatsapp.dashboard.statsStatus': 'Stato gruppi',
};
